<template>
  <el-dialog title="考核科目信息" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
             :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="90%"
             style="position: absolute; top: -40px;background-color: rgb(38 38 38 / 70%);"
             @close="dialogClose" v-el-drag-dialog v-el-dialog-center>
    <template>
      <div id="containt">
        <div class="grid-height">

          <div class="table_main" style="height: 400px!important;">
            <vxe-grid ref="table-m1"
                      :radio-config="{ highlight: true }"
                      :check-config="{ highlight: true }"
                      @cell-click="cellClickEvent"
                      @checkbox-change="changeEvent"
                      @checkbox-all="changeEvent"
                      show-overflow height="390"
                      :row-config="{ isHover: true }"
                      v-bind="vxeOption"
                      @resizable-change="$vxeTableUtil.onColumnWitchChange"
                      @custom="$vxeTableUtil.customHandle">

              <template #form>

                <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right"
                          :data="formData" @submit="searchEvent" @reset="searchEvent">
                  <vxe-form-item title="名称:" field="name">
                    <template v-slot>
                      <el-input v-model="formData.name" size="small" clearable/>
                    </template>
                  </vxe-form-item>
                </vxe-form>
                <div class="clearfix screen-btns">
                  <div class="fr" style="display: inline-block;
    float: right;
    margin-top: -39px;">
                    <vxe-button status="warning" icon="el-icon-search" class="button-sty"
                                @click="searchEvent">搜索
                    </vxe-button>
                  </div>
                </div>
              </template>
              <template #pager>
                <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
              </template>

              <template #checkType="{row}">
                <span v-if="row.checkType==1">处罚</span>
                <span v-else-if="row.checkType==2">奖励</span>
              </template>
            </vxe-grid>
          </div>
        </div>
      </div>
    </template>
    <span slot="footer" class="dialog-footer">
			<span class="fl tips" v-if="!selectMulti">注：双击确认选择（单选）</span>
			<el-button type="primary" plain class="button-sty" @click="dialogClose">
				<i class="el-icon-close el-icon"></i>
				取 消
			</el-button>
			<el-button type="primary" @click="commitRow" class="button-sty">
				<i class="el-icon-check el-icon"></i>
				确 定
			</el-button>
		</span>
  </el-dialog>
</template>

<script>
import {selectDialogMixins} from '@/mixins/selectDialog/index.js';
import {initVxeTable} from '@/const/crud/admin/tabletree'
import pager from '@/components/pager/index.vue'
import {fetchTree} from "@/api/admin/type_tree";
import api from "@/api/projectApi";

export default {
  name: 'checkSubjectDialog',
  props: ['visiable', 'multi', 'param'],
  mixins: [selectDialogMixins],
  components: {pager},

  created() {
    this.initTableList();
  },
  mounted() {
    let param = this.param
    if (param) {
      if (param.checkType) {
        this.formData.checkType = param.checkType
      }
      if (param.useWhere) {
        this.formData.useWhere = param.useWhere
      }
    }
  },

  data() {
    return {
      total: 0,
      filterText: '',
      clickRow: {id: null, type: false},
      data: [],
      defaultProps: {
        children: 'children',
        label: 'label',
        id: "id",
        isLeaf: "leaf"
      },
      pageSizes: [10, 20, 100],
      //以上树形
      activeName: 'second',
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      isRouterAlive: true,
      // 查询参数
      formData: {
        checkType: null,
        useWhere: null,
        usable: 1,
        parentId: 0
      },
      showDialog: true,
      falseValue: false,
      selectMulti: true,
      lastLevel: true,

      searchItemName: '',
      searchItemCode: '',
      searchBrandName: '',

    };
  },


  methods: {
    // 分页功能
    changeTablePage(page, flag) {
      this.formData.size = page.pageSize
      this.formData.current = page.currentPage
      this.formData.searchCount = flag
      this.initTableList();
    },
    flushed() {
      // this.$refs['table-m1'].commitProxy('reload');
    },

    cellClickEvent(e) {
      let id = e.row.id
      console.log(e.row, '单元格点击事件')
      this.lastLevel=e.row.hasChild
      if (this.clickRow.id == id && this.clickRow.type) {
        this.$refs['table-m1'].setRadioRow(e.row)
      } else {
        this.clickRow.type = true
        this.clickRow.id = id
        setTimeout(() => {
          this.clickRow.type = false
        }, 200)
      }
    },


    changeEvent({records}) {
      console.log('选中数据', records)
      this.selectedRow = records
    },


    commitRow() {
      // if(this.lastLevel){
      //   this.$message.warning('请选择到最后一级')
      //   return

      // }
      this.$emit('commitSelect', this.selectedRow)
      this.dialogClose()
    },


    // 搜索
    searchEvent() {
      this.formData.parentId = 0
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 重置
    resetEvent() {
      this.formData.name = ''
    },


    initTableList() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        tableName: 'basic_fault_code_list-m1',
        path: api.basCheckSubject.getTreeData,
        param: this.formData,
        method: 'post',
        columns: [
          {type: "checkbox", width: 40, title: '', resizable: false, fixed: 'left'},
          { title: '考核名称', field: 'name', treeNode: true, width: 410 },
          { title: '考核编码', field: 'code', width: 110, },
          { title: '类型', field: 'checkType', width: 110, slot: {default: 'checkType'}},
          { field: 'createTime', title: '创建时间', width: 200 },
          { title: '创建人', field: 'createBy', width: 110, },
        ]
      };
      this.vxeOption = initVxeTable(tableOption);
      // this.flushed()
    },


  }
};
</script>
<style lang="scss" scoped>
// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
  top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
  top: 0.3em;
}

#containt .grid-height {
  height: 400px;
}

::v-deep .el-dialog {
  // height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  // height: 700px;
  overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.table_main {
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid #ededed;
  // width: calc(100% - 215px);
  border-bottom: none;

  .el-pagination {
    padding: 2px;

  }
}

.left_tree {
  width: 205px;

  .title {
    text-align: left;
    width: 182px;
    padding: 7px 0 5px !important;
    font-size: 13px;
    color: rgba(58, 39, 39, 0.96);

    > span {
      position: relative;
      left: 4px;
      top: -3px;
    }
  }

  ::v-deep.el-tree-node__label {
    width: calc(100% - 32px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.tree_icon {
  background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }

  .el-tree-node__content {
    margin-top: 0px;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  & > .el-tree-node::after {
    border-top: none;
  }

  & > .el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;

    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }
}

::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon {
  font-size: 14px !important;
}

::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -53px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}
</style>
